<template>
  <div id="farmDetails">
    <b-card
      class="blockDrawer large"
      :class="$store.state.drawer.farmDetails.position"
    >
      <template v-slot:header>
        <a
          class="close clickable"
          @click="$store.commit('hideDrawer', 'farmDetails')"
        >
          <i class="far fa-times"></i>
        </a>
        <h4 class="card-title">{{ $store.state.farm.name }}</h4>
        <b-btn
          @click="editFarm()"
          class="mb-2 mr-1"
          v-if="$store.state.role == 'Administrator'"
        >
          <i class="fas fa-cog"></i> <span class="hide-mobile"></span>
        </b-btn>
        <b-btn
          @click="showCollaborators()"
          class="mb-2 mr-1"
          v-if="$store.state.role == 'Administrator'"
        >
          <i class="fas fa-users"></i> <span class="hide-mobile">Collaborators</span>
        </b-btn>
        <b-btn
          @click="createBlock()"
          class="mb-2 mr-1"
          v-if="$store.state.role == 'Administrator'"
        >
          <i class="fas fa-map-marked-alt"></i> <span class="hide-mobile">Create Blocks</span>
        </b-btn>
        <b-btn
          v-if="$store.state.role == 'Permission-only' || $store.state.role == 'Read-only'"
          class="mb-2"
          variant="secondary"
        >
          Read-only View: Changes will not save
        </b-btn>
        <b-btn
          v-if="$store.state.role == 'Editor'"
          class="mb-2"
          variant="secondary"
        >
          'Editor' Permission
        </b-btn>
      </template>
      <div class="card-top-nav">
        <ul class="nav nav-tabs">
          <li
            class="nav-item clickable"
            @click="detailsMode = 'settings'"
            v-b-tooltip.hover.bottom="'Visualize'"
          >
            <span class="nav-link"
            :class="{active:detailsMode == 'settings'}"><i class="far fa-sliders-h-square"></i></span>
          </li>
          <li
            class="nav-item clickable hide-mobile"
            @click="detailsMode = 'details'"
            v-b-tooltip.hover.bottom="'Details'"
          >
            <a class="nav-link"
            :class="{active:detailsMode == 'details'}"><i class="fas fa-info-circle"></i></a>
          </li>
          <li
            class="nav-item clickable"
            @click="detailsMode = 'list'"
            v-b-tooltip.hover.bottom="'List View'"
          >
            <span class="nav-link"
            :class="{active:detailsMode == 'list'}"><i class="fas fa-list"></i></span>
          </li>
          <li
            class="nav-item clickable"
            @click="detailsMode = 'downloads'"
            v-b-tooltip.hover.bottom="'Downloads'"
          >
            <a class="nav-link"
            :class="{active:detailsMode == 'downloads'}"><i class="fas fa-cloud-download-alt"></i></a>
          </li>
          <li
            class="nav-item clickable hide-mobile"
            @click="detailsMode = 'import'"
            v-b-tooltip.hover.bottom="'Import'"
            v-if="$store.state.role == 'Administrator'"
          >
            <a class="nav-link"
            :class="{active:detailsMode == 'import'}"><i class="fas fa-file-import"></i></a>
          </li>
        </ul>
      </div><!-- /.card-top-nav -->

      <div class="mt-5">
        <div v-if="detailsMode == 'settings'">
          <FarmVizSettings />
        </div><!-- /v-if detailsMode == 'settings' -->
        <div v-if="detailsMode == 'details'">
          <p><strong>Farm ID:</strong> {{ $store.state.farm.id }}</p>
          <p><strong>Created:</strong> {{ $store.state.farm.createdOn | dateTime }}</p>
          <p><strong>Updated:</strong> {{ $store.state.farm.updatedOn | dateTime }}</p>
          <p v-if="$store.state.blocksGeoJson.features.length > 0"><strong>Block Count:</strong> {{ $store.state.blocksGeoJson.features.length }}</p>
          <!-- Farm Blocks Description -->
          <div v-if="$store.state.farm.blockFields.length">
            <p class="mb-1 mt-3"><strong>Headers:</strong></p>
            <span
              v-for="(header, index) in $store.state.farm.blockFields"
              v-bind:key="index"
              class="badge badge-pill badge-secondary mr-1"
            >{{ header.label }}<span v-if="header.hidden"> (Hidden)</span></span>
          </div><!-- v-if headers -->
        </div><!-- /v-if detailsMode == 'settings' -->
        <div v-if="detailsMode == 'list'">
          <BlockList />
        </div><!-- /v-if detailsMode == 'list' -->
        <div v-if="detailsMode == 'downloads'">
          <p class="mb-1"><strong>Downloads</strong></p>
          <b-btn
            @click="download('geojson')"
            class="btn-primary mr-1"
          >
            <i class="far fa-file-download"></i> GeoJson
          </b-btn>
          <b-btn
            @click="download('csv')"
            class="btn-primary mr-1"
          >
            <i class="far fa-file-download"></i> CSV
          </b-btn>
          <b-btn
            @click="print()"
            class="btn-primary mr-1"
          >
            <i class="fas fa-print"></i> Print
          </b-btn>
        </div><!-- v-if import -->
        <div v-if="detailsMode == 'import'">
          <ImportData />
        </div><!-- v-if downloads -->
      </div><!-- /.mt-5 -->
    </b-card>
  </div><!-- /#farmDetails -->
</template>

<script>
import BlockList from '../block/BlockList'
import FarmVizSettings from './FarmVizSettings'
import ImportData from './ImportData'
import firebase from 'firebase/compat/app'
import axios from 'axios'
import shpwrite from 'shp-write'
import moment from 'moment'
import Papa from 'papaparse'

export default {
  data () {
    return {
      detailsMode: 'settings'
    }
  },
  computed: {
    farm: {
      get () {
        return this.$store.state.farm
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'farm', value: value })
      }
    }
  },
  components: {
    BlockList,
    FarmVizSettings,
    ImportData
  },
  methods: {
    print () {
      // this.$store.commit('setDrawer', { name: 'farmDetails', position: 'out' })
      this.$store.commit('showDrawer', 'farmDetails')
      const self = this
      setTimeout(() => {
        self.$store.commit('setStateProperty', { property: 'printingClass', value: 'printing' })
        document.body.style.backgroundColor = 'white'
        const map = self.$store.state.mapObject
        setTimeout(() => {
          map.resize()
          setTimeout(() => {
            window.print()
            self.$store.commit('setStateProperty', { property: 'printingClass', value: 'null' })
            document.body.style.backgroundColor = 'black'
            // self.$store.commit('setDrawer', { name: 'farmDetails', position: 'in' })
            this.$store.commit('hideDrawer', 'mapDetails')
          }, 500)
        }, 500)
      }, 1000)
    },
    download (option) {
      let path
      let fileName
      const cleanDescription = this.farm.name.replace(/\s+/g, '_')
      if (option === 'geojson' || option === 'csv') {
        path = this.farm.blocksGeoJsonPath
        if (option === 'geojson') {
          fileName = cleanDescription + '.geojson'
        } else if (option === 'csv') {
          fileName = cleanDescription + '.csv'
        }
      }
      if (option === 'shp') {
        path = this.$store.state.dataset.file.geoJsonPath
        fileName = cleanDescription
      }
      const storageRef = firebase.storage().ref(path)
      if (option === 'geojson') {
        storageRef.getDownloadURL().then(url => {
          return fetch(url)
        }).then(response => {
          return response.blob()
        }).then(blob => {
          return URL.createObjectURL(blob)
        }).then(object => {
          const a = document.createElement('a')
          a.href = object
          a.download = fileName
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }).catch(err => {
          console.log(err)
        })
      } else if (option === 'csv') {
        storageRef.getDownloadURL().then(url => {
          return axios.get(url)
        }).then(response => {
          const geoJsonData = response.data
          const items = []
          geoJsonData.features.forEach(feature => {
            const jsonObject = feature.properties
            if (jsonObject.createdOn) {
              console.log(jsonObject)
              const date = jsonObject.createdOn * 1000
              jsonObject.createdOn = moment(date).format('YYYY-MM-DD HH:mm:ss')
            }
            if (jsonObject.updatedOn) {
              const date = jsonObject.updatedOn * 1000
              jsonObject.updatedOn = moment(date).format('YYYY-MM-DD HH:mm:ss')
            }
            // jsonObject.longitude = feature.geometry.coordinates[0]
            // jsonObject.latitude = feature.geometry.coordinates[1]
            const header = Object.keys(jsonObject)
            if (this.farm.blockFields) {
              this.farm.blockFields.forEach(headerItem => {
                if (!header.includes(headerItem.label) && headerItem.type !== 'Image') {
                  jsonObject[headerItem.label] = ''
                }
                if (headerItem.type === 'Date and Time' && header.includes(headerItem.label)) {
                  const headerDate = jsonObject[headerItem.label] * 1000
                  if (headerItem.includeTime) {
                    jsonObject[headerItem.label] = moment(headerDate).format('YYYY-MM-DD HH:mm:ss')
                  } else {
                    jsonObject[headerItem.label] = moment(headerDate).format('YYYY-MM-DD')
                  }
                }
              })
            }
            items.push(jsonObject)
          })
          console.log(items)
          const csv = Papa.unparse(items)
          // const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
          // const header = Object.keys(items[0])
          // Check that all headers are represented
          // if (this.farm.blockFields) {
          //   this.farm.blockFields.forEach(headerItem => {
          //     if (!header.includes(headerItem.label) && headerItem.type !== 'Image') {
          //       header.push(headerItem.label)
          //     }
          //   })
          // }
          // let csv = items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
          // csv.unshift(header.join(','))
          // csv = csv.join('\r\n')
          const blob = new Blob([csv], { type: 'text/csv' })
          return URL.createObjectURL(blob)
        }).then(object => {
          const a = document.createElement('a')
          a.href = object
          a.download = fileName
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }).catch(err => {
          console.log(err.message)
        })
      } else if (option === 'shp') {
        storageRef.getDownloadURL().then(url => {
          return axios.get(url)
        }).then(response => {
          const geoJsonData = response.data
          const downloadOptions = {
            folder: cleanDescription + '_' + option,
            types: {
              point: cleanDescription + '_points',
              polygon: cleanDescription + '_polygons',
              line: cleanDescription + '_lines'
            }
          }
          shpwrite.download(geoJsonData, downloadOptions)
        })
      }
    },
    showCollaborators () {
      this.$store.commit('hideAllDrawers')
      setTimeout(() => {
        this.$store.commit('showDrawer', 'collaborators')
      }, 300)
    },
    createBlock () {
      this.$store.commit('setEditMode', false)
      this.$store.commit('hideAllDrawers')
      setTimeout(() => {
        this.$store.commit('showDrawer', 'createBlockDrawer')
      }, 300)
    },
    showTrustees () {
      this.$store.commit('hideDrawer', 'trailSystemDetails')
      setTimeout(() => {
        this.$store.commit('showDrawer', 'trustees')
      }, 300)
    },
    editFarm () {
      this.$store.commit('setEditMode', true)
      this.$store.commit('hideDrawer', 'farmDetails')
      setTimeout(() => {
        this.$store.commit('showDrawer', 'createFarm')
      }, 300)
    }
  },
  filters: {
    dateTime (val) {
      if (!val) { return '-' }
      const date = val.toDate()
      return moment(date).format('MMMM Do YYYY, h:mm a')
    }
  }
}
</script>

<style scoped>
.card-top-nav {
  position:absolute;
  top: 100px;
  z-index:50;
  background-color:white;
  width:100%;
  left:0;
  background-color: #eee;
}
.card-top-nav .nav-tabs .nav-link {
  border-radius: 0;
  background-color: #eee;
  color: #333;
}

.card-top-nav .nav-link.active {
  background-color: #ddd;
}
@media(max-width:800px) {
  .card-top-nav {
    top: 90px;
  }
}
</style>
